import { useState, useEffect } from 'react';
import { getEmployments } from 'api';
import type { EmploymentType } from 'interfaces';

export const useFetchEmploymentTypes = () => {
  const [employmentTypes, setEmploymentTypes] = useState<EmploymentType[]>([]);

  useEffect(() => {
    let stillMounted = true;

    const getData = async () => {
      try {
        const response = await getEmployments();
        setEmploymentTypes(response.data);
      } catch (error) {
        setEmploymentTypes([]);
        throw error;
      }
    };

    if (stillMounted) {
      getData();
    }

    return () => {
      stillMounted = false;
    };
  }, []);

  return { employmentTypes };
};
